import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TableState } from 'primeng/api';
import { UiSettingsIdentifier } from './ui-user-settings.service';
import { LocalStorageTableSettingsService } from '@avano/avano-components/avano-table/avano-table-settings.service';
import { Store } from '@ngrx/store';
import { selectSubmissionsPageUserSettings, SubmissionPageActions } from '../store/submissions-page';
import { selectProductsPageUserSettings } from '../store/products-page/products-page.selectors';
import { ProductsPageActions } from '../store/products-page';

// We replace/extend the default mechanism that the table state of a primeng/avano
// table is only saved in the localStorage. We want some tables (important ones)
// to save the settings for within the db, so that the settings are synced across
// multiple browsers/pcs for one user.
@Injectable({
  providedIn: 'root'
})
export class ScipTableDbSettingsService extends LocalStorageTableSettingsService {
  private versionFlag = '4.1.3';

  constructor(private store: Store) {
    super();
  }

  getSettings: (tableIdentifier: string) => Observable<TableState> = (tableIdentifier) => {
    switch (tableIdentifier) {
      case UiSettingsIdentifier.SubmissionsTable:
        return this.store.select(selectSubmissionsPageUserSettings);
      case UiSettingsIdentifier.ProductsTable:
        return this.store.select(selectProductsPageUserSettings);
      default:
        return super.getSettings(tableIdentifier);
    }
  };
  saveSettings: (tableIdentifier: string, state: TableState) => Observable<boolean> = (identifier, newState) => {
    // Currently, only our submissions- and our products-table are saving their settings in the db
    // Other tables (which are not that important) can be saved within the local storage
    // But if one of them should be saved too in the db, then we need to add them here
    switch (identifier) {
      case UiSettingsIdentifier.SubmissionsTable:
        this.store.dispatch(SubmissionPageActions.setUserSettings({ settings: newState, versionFlag: this.versionFlag }));
        return of(true);
      case UiSettingsIdentifier.ProductsTable:
        this.store.dispatch(ProductsPageActions.setUserSettings({ settings: newState, versionFlag: this.versionFlag }));
        return of(true);

      default:
        return super.saveSettings(identifier, newState);
    }
  };
}
